import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const dashboardViewActionsI18n = {
	[ELocaleCode.RU_RU]: {
		addExpense: 'Добавить',
	},
	[ELocaleCode.EN_US]: {
		addExpense: 'Add Expense',
	},
};
